<template>
  <div>
    <div class="heat-map"></div>
    <div class="heat-map-info">
      <div class="heat-map-info__label">
        {{ title }}
      </div>
      <div v-if="interactions" class="heat-map-info__data">
        Interactions: {{ interactions }}
      </div>
      <div v-if="playbackPercentage" class="heat-map-info__data">
        Playback Percentage: {{ playbackPercentage }}%
      </div>
      <div v-if="dateRange" class="heat-map-info__data">
        Date Range: {{ convertTimestampToDate(dateRange[0]) + ' - ' + convertTimestampToDate(dateRange[1]) }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

export default {
  props: ['dateRange', 'interactions', 'title'],

  computed: {
    ...mapGetters({
      playbackPercentage: 'interactions/playbackPercentage'
    })
  },

  methods: {
    convertTimestampToDate (timestamp) {
      return DateTime.fromMillis(Number(timestamp)).toLocaleString({ 
        month: 'long', 
        day: 'numeric',
        year: 'numeric',
      })
    },
  }
}
</script>

<style lang="scss">
.heat-map-info {
  background: rgba(0, 0, 0, .6);
  left: 0;
  padding: 1rem;
  position: absolute;
  top: 1rem;
  width: 40rem;
  z-index: 10001;

  &__label {
    font-size: 1.2rem;
    font-weight: 700;
  }

  &__data {
    font-size: 1.1rem;
  }
}
</style>